import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import { SectionField, TemplateSection } from '../typings';
import SectionFieldContainer from './SectionFieldContainer';

interface TemplateSectionContainerProps {
  isMobile: boolean;
  templateSection: TemplateSection;
}

function renderTemplateSectionTitle(isMobile: boolean, templateSection: TemplateSection) {
  if (isMobile) {
    return (
      <Typography
        variant='body1'
        style={{ fontWeight: 700, backgroundColor: '#f1f1f1', padding: '0.75rem' }}
        key={templateSection.name}
        align='center'
      >
        {templateSection.name}
      </Typography>
    );
  }
  return (
    <Typography variant='body1' style={{ fontWeight: 500, backgroundColor: 'white' }} key={templateSection.name}>
      {templateSection.name}
    </Typography>
  );
}

const TemplateSectionContainer: React.FC<TemplateSectionContainerProps> = (templateSectionProps) => {
  const { isMobile, templateSection } = templateSectionProps;
  return (
    <div>
      {renderTemplateSectionTitle(isMobile, templateSection)}
      {templateSection.sectionFields.map((eachSectionField: SectionField) => (
        <div key={`${eachSectionField.name}-${eachSectionField.rank}`}>
          <SectionFieldContainer isMobile={isMobile} sectionFieldDetails={eachSectionField} sectionRank={templateSection.rank} />
        </div>
      ))}
    </div>
  );
};

export default TemplateSectionContainer;
